<!-- The Preview Ingredients Component -->
<!-- Description: Creating an ingredients for the base modal component -->
<template>
    <div>
        <div @click="$emit('ingredients', !showIngredients)" class="ingredients"
             v-if="product.attributes.ingredients.length !== 0">
            <p class="margin-left title"
               style="padding-top: 20px; padding-bottom: 20px; font-size: 16px; margin-top: 15px; margin-bottom: 15px;">
                Съставки
            </p>
        </div>
        <b-collapse id="collapse-1" v-model="showIngredients">
            <div class="margin-left" v-for="(ingredient, index) in product.attributes.ingredients">
                <input type="checkbox" class="form-checkbox" :id="ingredient.name + 'radio_' + index"
                       checked :disabled="ingredient.is_optional === '1'" v-model="selected.ingredients"
                       :value="ingredient.name">
                <label :for="ingredient.name + 'radio_' + index">
                    {{ ingredient.name }}
                </label>
            </div>
        </b-collapse>
    </div>
</template>

<!-- TypeScript code -->
<script>
    export default {
        name: 'ThePreviewIngredients',
        props: {
            product: Object,
            selected: Object,
            showIngredients: Boolean,
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .ingredients { background: #ebebeb; cursor: pointer; }
    .ingredients:hover { background-color: darken(#ebebeb, 20%); }
    input[type][disabled] { background-color: #f9f9f9; color: #ddd; cursor: default; }
    input[type][disabled] + label { color: #999; cursor: default; }
    .margin-left { margin-left: 15px; }
    label {
        font: 300 16px/1.7 'Open Sans', sans-serif;
        color: #666;
        cursor: pointer;
    }
</style>